import type {ComponentPropsWithRef} from 'react';
import React from 'react';
import {withCssModule} from '@pb/kit-util-with-css-module';

import styles from './table.module.styl';

const classNames = withCssModule(styles);

export type CaptionProps = ComponentPropsWithRef<'caption'>;

export const Caption = ({
    children,
    className,
    ref,
    ...rest
}: CaptionProps) => (
    <caption {...rest} ref={ref} className={classNames('table__caption', className)}>
        {children}
    </caption>
);
